/* global modForm Set */
import {
	getFormData,
	getOwnHomeValue,
	serviceCodesAndAttributions,
	trackFormSubmissionFlow
} from '../../helpers';

/**
 * This function maps the serviceSpecificAttributes based on current trade
 * @param {String} serviceCode - serviceCode
 */
export function mapServiceSpecificAttributes(serviceCode) {
	trackFormSubmissionFlow({ inMapServiceSpecificAttributes: true });
	const currentFormData = getFormData();

	function getAttributeValue(elementName) {
		trackFormSubmissionFlow({ inGetAttributeValue: true });
		if (modForm.opts.form && elementName) {
			switch (elementName) {
			case 'OwnHome': {
				modForm.opts.serviceSpecificAttributes[elementName] = getOwnHomeValue();
				break;
			}
			case 'CommercialLocation':
				modForm.opts.serviceSpecificAttributes.CommercialLocation = currentFormData.CommercialLocation === 'Homerent' ? 'Home' : currentFormData.CommercialLocation;
				if (serviceCode === 'HOME_SECURITY' && (!currentFormData.OwnHome || currentFormData.OwnHome.trim() === '')) {
					modForm.opts.serviceSpecificAttributes.OwnHome = currentFormData.CommercialLocation !== 'Homerent' ? 'Yes' : 'No';
				}
				break;
			case 'HVACProjectScope':
				modForm.opts.serviceSpecificAttributes.HVACProjectScope = (currentFormData.HVACProjectScope === 'Repair' && currentFormData.ReadyToReplace === 'Yes') ? 'Install' : currentFormData.HVACProjectScope;
				break;
			case 'HVACInterest':
				modForm.opts.serviceSpecificAttributes.HVACInterest = currentFormData.HVACInterest.replace(' Heat Pump', '');
				if (['Central Heating', 'Boiler/Radiator'].includes(modForm.opts.serviceSpecificAttributes.HVACInterest)) {
					const system = modForm.opts.serviceSpecificAttributes.HVACInterest.replace(' ', '').replace('/Radiator', 'System');
					modForm.opts.serviceSpecificAttributes[`${system}${modForm.opts.serviceSpecificAttributes.HVACProjectScope}Type`] = currentFormData.BoilerHeatingInstallRepairType;
				}
				modForm.opts.serviceSpecificAttributes.HVACInterest = `${modForm.opts.serviceSpecificAttributes.HVACProjectScope} ${modForm.opts.serviceSpecificAttributes.HVACInterest}`;
				break;
			case 'NumberOfWindows':
				modForm.opts.serviceSpecificAttributes.NumberOfWindows = (currentFormData.NumberOfWindows === '1' && currentFormData.MultipleWindows === 'Yes') ? '3-5' : currentFormData.NumberOfWindows;
				break;
			case 'ConcreteProjectScope':
				modForm.opts.serviceSpecificAttributes.ConcreteProjectScope = (currentFormData.service === 'CONCRETE_FOUNDATION' ? 'Repair' : currentFormData.ConcreteProjectScope);
				break;
			case 'RoofingPlan': {
				const options = modForm.opts.roofingPlanOptions;
				const projectScope = currentFormData.RoofingProjectScope;
				modForm.opts.serviceSpecificAttributes.RoofingPlan = (projectScope && projectScope in options) ? options[projectScope] : options.Replace;
				break;
			}
			default:
				if (!currentFormData[elementName]) {
					return;
				}
				modForm.opts.serviceSpecificAttributes[elementName] = Array.isArray(currentFormData[elementName]) ? JSON.stringify(currentFormData[elementName]) : currentFormData[elementName];
			}
		}
	}

	for (const service of serviceCodesAndAttributions) {
		if (service.serviceCodes.includes(serviceCode)) {
			if (Object.keys(modForm.opts.serviceSpecificAttributes).length) {
				modForm.opts.serviceSpecificAttributes = {};
			}
			service.requiredAttributes.forEach(attribute => {
				getAttributeValue(attribute);
			});
			const dataHbAttributes = [...new Set(
				Array.from(modForm.opts.form.querySelectorAll('[data-hb]')).filter(el => !el.closest('.skipped')).map(el => el.name).filter(Boolean)
			)];
			const homebuddyAttributes = Array.isArray(service.homebuddyAttributes) ? [...service.homebuddyAttributes, ...dataHbAttributes] : dataHbAttributes;
			if (homebuddyAttributes.length) {
				homebuddyAttributes.forEach(attribute => {
					getAttributeValue(attribute);
				});
			}
		}
	}
}
